import { render, staticRenderFns } from "./AppointmentSometryModal.vue?vue&type=template&id=06b7da13&"
import script from "./AppointmentSometryModal.vue?vue&type=script&lang=js&"
export * from "./AppointmentSometryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports